import { useLang } from "../context/LanguageContext";
import { IntroLoader } from "../components/vero/IntroLoader";
import { VideoHero } from "../components/vero/VideoHero";
import { DiscoverSection } from "../components/vero/DiscoverSection";
import { ScrollerStepper } from "../components/vero/ScrollerStepper";
import { SecondaryHero } from "../components/vero/SecondaryHero";
import { DiptychSection } from "../components/vero/DiptychSection";
import { MediaGridSection } from "../components/vero/MediaGridSection";
import { ClassLiveSection } from "../components/vero/ClassLiveSection";
import { LargeQuoteSection } from "../components/vero/LargeQuoteSection";
import { ScheduleSection } from "../components/landing/ScheduleSection";
import { PricingSection } from "../components/landing/PricingSection";
import { LocationSection } from "../components/landing/LocationSection";
import { Reassurance } from "../components/vero/Reassurance";

export default function Landing() {
  const { t } = useLang();
  return (
    <main data-testid="landing-page">
      <IntroLoader />
      <VideoHero />
      <DiscoverSection />
      <ScrollerStepper />
      <SecondaryHero id="perfection" uptitle={t.hero2a.uptitle} title={t.hero2a.title} />
      <DiptychSection />
      <SecondaryHero id="masterpiece" uptitle={t.hero2b.uptitle} title={t.hero2b.title} />
      <ClassLiveSection />
      <LargeQuoteSection />
      <ScheduleSection />
      <PricingSection />
      <LocationSection />
      <Reassurance />
    </main>
  );
}
